const default_data = {};
export default {
  namespaced: true,
  state: {
        data: {}
  },
  mutations: {
        setData(state, data) {
            state.data = data;
        },
        removeData(state) {
          state.data = default_data;
        }
  },
  actions: {
    setData({state, commit}, data) {
        commit('setData', data)
    }
  },
  getters: {
        data(state) {
            return state.data;
        }
  }
}
